var render = function () {
  var _vm$item$buyer, _vm$item$seller;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-list-item', _vm._g({}, _vm.hasClickListener ? {
    click: function click() {
      return _vm.$emit('click');
    }
  } : {}), [_vm._t("icon"), _vm.hasActionListener ? _c('v-list-item-action', [_vm._t("action")], 2) : _vm._e(), _c('v-list-item-content', [!_vm.small ? _c('v-list-item-subtitle', {
    staticClass: "text-xs"
  }, [_c('v-chip', {
    staticClass: "mr-1",
    attrs: {
      "color": _vm.item.statusColor,
      "x-small": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("enums.InvoiceStatusEnum.".concat(_vm.item.status))) + " ")]), _c('span', [_vm._v(" " + _vm._s(_vm._f("simpleDate")(_vm.item.date)) + " ")])], 1) : _vm._e(), _c('v-list-item-title', [_vm.hasOpenDetailListener ? _c('a', {
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.emitOpenDetail.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("enums.InvoiceTypeEnum.".concat(_vm.item.type))) + " " + _vm._s(_vm.item.titleReadable) + " ")]) : _c('div', [_vm._v(_vm._s(_vm.$t("enums.InvoiceTypeEnum.".concat(_vm.item.type))) + " " + _vm._s(_vm.item.titleReadable))])]), !_vm.small ? _c('v-list-item-subtitle', [_vm.item.isOutbound ? _c('span', [_vm._v(" " + _vm._s((_vm$item$buyer = _vm.item.buyer) === null || _vm$item$buyer === void 0 ? void 0 : _vm$item$buyer.name) + " - ")]) : _c('span', [_vm._v(" " + _vm._s((_vm$item$seller = _vm.item.seller) === null || _vm$item$seller === void 0 ? void 0 : _vm$item$seller.name) + " - ")]), _c('span', [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.item.subTotal, _vm.item.currency)) + " ")])]) : _vm._e()], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }